<template>
<div class="chapter">
<div class="inner_page">
<p class="right" id="tp"><span class="big1"><strong>2061: Odyssey Three</strong></span><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="right">Arthur C. Clarke</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795324857_epub_tp_r1.vue?493e27fd